import moment from 'moment'
import accounting from 'accounting'
import config from '../config'
// var moment = require('moment')
// window.moment = moment
// var accounting = require('accounting')
// window.accounting = accounting

export function createCookie(name, value, days) {
  let expires = ''
  if (days) {
    let date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  // Secure is only valid over https; adding it on http (localhost/dev) would silently drop the cookie.
  const secure = typeof window !== 'undefined' && window.location && window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax' + secure
}

export function deleteCookie(tokenAlias) {
  document.cookie = tokenAlias + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;'
}

export function getCookie(cName) {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) {
        cEnd = document.cookie.length
      }
      const raw = document.cookie.substring(cStart, cEnd)
      try {
        return decodeURIComponent(raw)
      } catch (e) {
        return raw
      }
    }
  }
  return ''
}

// Persist the IB referral code across cookie + localStorage + sessionStorage so it
// survives storage restrictions on any single mechanism (Safari ITP, private mode, blockers).
// Exported as plain helpers so router/auth redirects can use them before App.vue mounts.
export function setReferralCode(code) {
  const value = typeof code === 'string' ? code.trim() : code || code === 0 ? String(code).trim() : ''
  if (!value) {
    return
  }
  createCookie('refcode', value, 30)
  try {
    window.localStorage.setItem('refcode', value)
  } catch (e) {
    /* storage unavailable */
  }
  try {
    window.sessionStorage.setItem('refcode', value)
  } catch (e) {
    /* storage unavailable */
  }
}

export function getReferralCode() {
  const cookie = (getCookie('refcode') || '').trim()
  if (cookie) {
    return cookie
  }
  let local = ''
  try {
    local = (window.localStorage.getItem('refcode') || '').trim()
  } catch (e) {
    local = ''
  }
  if (local) {
    return local
  }
  let session = ''
  try {
    session = (window.sessionStorage.getItem('refcode') || '').trim()
  } catch (e) {
    session = ''
  }
  return session
}

export default {
  install(Vue) {
    // Vue.directive('currency-format', {
    // 	bind(el, binding, vnode, oldVnode){
    // 		let opt = binding.expression
    // 		let val = parseFloat(el.innerHTML)
    // 		if (isNaN(val)){
    // 			return
    // 		}
    // 		el.innerHTML = accounting.formatMoney(val, opt.currency, opt.precision, opt.decimal, opt.thousand)
    // 	}
    // })

    Vue.prototype.$createCookie = createCookie
    Vue.prototype.$deleteCookie = deleteCookie
    Vue.prototype.$getCookie = getCookie
    Vue.prototype.$setReferralCode = setReferralCode
    Vue.prototype.$getReferralCode = getReferralCode
    Vue.prototype.$formatMoney = (value, options) => accounting.formatMoney(value, { precision: 2, ...options });
    Vue.prototype.$formatDate = function (t) {
      return moment(t).format('DD/MM/YYYY')
    }
    Vue.prototype.$formatDateTime = function (t) {
      return moment(t).format('YYYY-MM-DD HH:mm')
    }
    Vue.prototype.$dateFromNow = function (t) {
      return moment(t).fromNow()
    }
    Vue.prototype.$statusFormat = function (str) {
      if (str === 'full') {
        return this.$t('client_state_approved').tTitle()
      } else if (str === 'pending') {
        return this.$t('client_state_pending').tTitle()
      } else {
        return ''
      }
    }
    Vue.prototype.$validateEmail = function (str) {
      if (str == '')
        return
      // eslint-disable-next-line
      if (str.match(/^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/)) {
        return true
      }
      return false
    }
    Vue.prototype.$getRouteName = function (raw) {
      if (raw === null) {
        return ''
      }
      return raw.substring(0, raw.indexOf('|') - 1)
    }
    Vue.prototype.$elementParentExists = function (el, parentSelector) {
      if (parentSelector === undefined) {
        return false
      }
      let p = el.parentElement
      if (p === null) {
        return false
      }
      while (p !== parentSelector) {
        p = p.parentElement
        if (p === null) {
          return false
        }
      }
      return true
    }
    Vue.prototype.$escapeHtml = function (str) {
      let entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;',
      }
      // return String(str).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
      // 	return entityMap[s]
      // })
      return String(str).replace(/[&<>"'`=/]/g, s => entityMap[s])
    }
    Vue.prototype.$simplePair = function (pair) {
      if (pair.indexOf('.') !== -1) {
        return pair.split('.')[0]
      }
      return pair
    }
    Vue.prototype.$randomString = function () {
      let rstr = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      return rstr
    }

    Vue.prototype.dragContainer = function (id) {
      const slider = document.querySelector(id)
      let isDown = false
      let startX
      let scrollLeft

      if (!slider) {
        return
      }

      slider.addEventListener('mousedown', e => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
        slider.style.cssText = 'cursor: grabbing;cursor: -webkit-grabbing;'
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
        slider.removeAttribute('style')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
        slider.removeAttribute('style')
      })
      slider.addEventListener('mousemove', e => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3 // scroll-fast
        slider.scrollLeft = scrollLeft - walk
      })
    },
    Vue.prototype.$rankFormat = function (num) {
      if (typeof num !== 'number' || num < 1) return ''; // Return an empty string for invalid inputs

      const lastDigit = num % 10;
      const lastTwoDigits = num % 100;

      // Handle special cases for numbers ending in 11, 12, 13
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${num}th`;

      // Handle general cases
      switch (lastDigit) {
        case 1:
          return `${num}${this.$t('st')}`;
        case 2:
          return `${num}${this.$t('nd')}`;
        case 3:
          return `${num}${this.$t('rd')}`;
        default:
          return `${num}${this.$t('th')}`;
      }
      }
    Vue.prototype.addMeta = function (type, value) {
      if (type == 'title') {
        document.title = value
      } else if (type == 'ogtitle') {
        document.querySelector('meta[property="og:title"]').setAttribute('content', value)
      } else if (type == 'description') {
        document.querySelector('meta[name="description"]').setAttribute('content', value)
        document.querySelector('meta[property="og:description"]').setAttribute('content', value)
      } else if (type == 'canonical') {
        document.querySelector('link[rel="canonical"]').setAttribute('href', value)
      } else if (type == 'alternate') {
        // Remove existing alternate links
        const existingLinks = document.querySelectorAll('link[rel="alternate"]')
        existingLinks.forEach(link => link.remove())

        const path = value.startsWith('/') ? value.slice(1) : value

        for (let lang in config.languages) {
          // x-default link
          const defaultLink = document.createElement('link')
          defaultLink.rel = 'alternate'
          defaultLink.hreflang = 'x-default'
          defaultLink.href = `${config.URL.cp}/${lang}/${path}`
          document.head.appendChild(defaultLink)

          // hreflang specific link
          const langLink = document.createElement('link')
          langLink.rel = 'alternate'
          langLink.hreflang = lang
          langLink.href = `${config.URL.cp}/${lang}/${path}`
          document.head.appendChild(langLink)
        }
      }
    }
  },
}
